module.exports = __webpack_public_path__ + "img/youtube-icon.4620173.svg";